import { getKeyForBrowser } from "../../utilities/Helpers";
import { SpaceStore, ItemStore, SubspaceStore } from "../ELYXStore";
import ItemMethods from "../Items/ItemMethods";

const SpaceUtilities = {
  getSpaceID(itemID = "") {
    let spaceID = "";
    if (SpaceStore.state.space && SpaceStore.state.space._id) {
      /** If a Space is active and selected, use that */
      spaceID = SpaceStore.state.space._id;
    } else if (itemID) {
      /** If no active Space selected, such as when inside a Search Result which has no particular
       * context, then attempt to extract SpaceID from item the tag is being added to. */
      const existingItem = ItemStore.state.items.find((item) => item._id === itemID);
      if (existingItem && existingItem.spaceID) {
        spaceID = existingItem.spaceID;
      }
    }
    return spaceID;
  },

  isDisabledShortcut(event, unallowedClasses) {
    const className = event.target.className;
    const classList = event.target.classList;

    if (unallowedClasses.includes(className)) {
      return true;
    }

    for (let i = 0; i < unallowedClasses.length; i++) {
      if (classList.contains(unallowedClasses[i])) {
        return true;
      }
    }
  },

  blurInputOnEscape(event, inputClasses) {
    const className = event.target.className;
    const classList = event.target.classList;

    for (let i = 0; i < inputClasses.length; i++) {
      if (className == inputClasses[i] || classList.contains(inputClasses[i])) {
        document.getElementsByClassName(inputClasses[i])[0].blur();
      }
    }
  },

  handleSpaceKeypress(event) {
    /* event.preventDefault(); */
    const key = getKeyForBrowser(event);
    if (!key) return;

    /** Handle escapes */
    if (key === 27) {
      /** If any Tagger is open, close it */
      ItemStore.methods.closeAllItemTaggers();
      SubspaceStore.methods.closeAllSubspaceDropdowns();
    }

    /** Handle shortcuts used inside inputs */
    const inputClasses = ["ProseMirror"];
    if (SpaceUtilities.isDisabledShortcut(event, inputClasses)) {
      /** If user uses escape in an input field */
      if (key == 27) {
        SpaceUtilities.blurInputOnEscape(event, inputClasses);
      } else {
        /** Cancel shortcut if user is currently inside an input field */
        return;
      }
    }

    /** @todo PREVENT IF MULTIPLE ITEMS SELECTED */
    if (event.shiftKey && key === 68) {
      /** shift + d —> complete/uncomplete selected item */
      ItemMethods.toggleSelectedItemComplete();
    } else if (key === 40) {
      ItemMethods.selectNextItemInList();
    } else if (key === 38) {
      ItemMethods.selectPrevItemInList();
    }
  },

  handleSpaceClicks(event) {
    /** If user clicks outside an ItemTagger and its children, close all item taggers. */
    if (!event.target.closest(".ItemTagger")) {
      ItemStore.methods.closeAllItemTaggers();
    }
    if (!event.target.closest(".subspaceHeaderDropdown")) {
      SubspaceStore.methods.closeAllSubspaceDropdowns();
    }
  },
};

export default SpaceUtilities;
